import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  topFiltersBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20,
    [theme.breakpoints.down(theme.size.sm)]: {
      padding: 10,
    },
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  flexBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  divider: {
    marginLeft: 10,
    marginRight: 10,
    color: '#fff',
  },
  ml20: {
    marginLeft: 20,
  },
  mb20: {
    marginBottom: 20,
  },
  toggleBtn: {
    minWidth: 'auto',
    padding: 2,
    background: '#fff',
    borderRadius: '50%',
    color: '#000',
    '&:hover': {
      background: theme.custom.lightBlue,
      color: '#fff',
    },
  },
  activeToggleIcon: {
    transform: 'rotate(180deg)',
  },
  title: {
    margin: 0,
    fontSize: 30,
    fontWeight: 600,
    color: '#fff',
    [theme.breakpoints.down(theme.size.sm)]: {
      fontSize: 26,
    },
    [theme.breakpoints.down(490)]: {
      fontSize: 21,
    },
  },
  inputWrapper: {
    maxWidth: 400,
    width: '100%',
    [theme.breakpoints.down(theme.size.sm)]: {
      maxWidth: '100%',
    },
  },
  summaryLabel: {
    display: 'block',
    fontSize: 19,
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 17,
    },
    [theme.breakpoints.down(theme.size.sm)]: {
      fontSize: 15,
    },
  },
  value: {
    display: 'block',
    fontSize: 28,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down(theme.size.sm)]: {
      fontSize: 18,
    },
  },
  summaryList: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    margin: 0,
    padding: '30px 20px',
    background: '#fff',
    borderLeft: `8px solid ${theme.custom.darkBlue}`,
    listStyle: 'none',
    [theme.breakpoints.down(theme.size.sm)]: {
      padding: '15px 10px',
    },
  },
  summaryItem: {
    color: theme.custom.darkBlue,
    [theme.breakpoints.down(theme.size.sm)]: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: 20,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  green: {
    color: '#218D7A',
  },
  orange: {
    color: '#FF7600',
  },
  modalBackground: {
    background: '#eff2f7',
  },
  mobileFiltersBar: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  mobileFiltersLeft: {
    width: '100%',
    marginBottom: 20,
  },
  mobileFiltersRight: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    [theme.breakpoints.down(490)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  mobileDatePickerWrapper: {
    [theme.breakpoints.down(490)]: {
      width: '100%',
      marginLeft: 0,
    },
  },
  mobileSummaryTopBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 10,
    background: '#fff',
    borderLeft: '8px solid #224060',
    [theme.breakpoints.down(theme.size.sm)]: {
      marginBottom: 20,
    },
  },
  mobileSummaryTitle: {
    margin: 0,
    fontSize: 17,
    color: theme.custom.darkBlue,
  },
  mobileSummaryToggleBtn: {
    background: '#f0f3f7',
  },
}));
